import Padding from '@sdk/components/ui/spacing/Padding';

import Button from '@kiosk/common/components/Button';
import ButtonContainer from '@kiosk/common/components/Forms/ButtonContainer';
import AttestationOptions from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AttestationView/AttestationOptions/AttestationOptions';
import AttestationSpecifyView from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AttestationView/AttestationSpecifyView/AttestationSpecifyView';
import UserAvatar from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AttestationView/UserAvatar/UserAvatar';

import { updateAttestationOption, updateAttestationText } from './attestationView.actions';
import { getHeaderText } from './attestationView.utils';
import { AttestationItemStep } from './attestationView.types';
import { useAttestationView } from './attestationView.hooks';

const AttestationView = () => {
  const {
    user,
    attestationsCount,
    currentAttestationItem,
    proceedButton,
    cancelButton,
    dispatch,
    currentAttestationIndex
  } = useAttestationView();

  return (
    <>
      <Padding bottom={40}>
        <UserAvatar
          avatar={user.avatar}
          name={user.name}
          lastname={user.lastname}
          subText={getHeaderText(
            currentAttestationItem,
            attestationsCount[currentAttestationItem.breakType]
          )}
        />
      </Padding>
      <>
        {currentAttestationItem.step === AttestationItemStep.first ? (
          <AttestationOptions
            currentAttestationItem={currentAttestationItem}
            onClick={value =>
              dispatch(
                updateAttestationOption({ attestIndex: currentAttestationIndex, option: value })
              )
            }
          />
        ) : (
          <>
            <AttestationSpecifyView
              attestationItem={currentAttestationItem}
              onChange={value => {
                dispatch(
                  updateAttestationText({ attestIndex: currentAttestationIndex, text: value })
                );
              }}
            />
          </>
        )}
      </>

      <ButtonContainer delay={0.4}>
        <Button
          disabled={proceedButton.isDisabled}
          label={proceedButton.label}
          themeColor={proceedButton.themeColor}
          buttonTheme={proceedButton.buttonTheme}
          onPress={proceedButton.action}
        />
        <Button
          label={cancelButton.label}
          buttonTheme={cancelButton.buttonTheme}
          onPress={cancelButton.action}
          withMargin
        />
      </ButtonContainer>
    </>
  );
};

export default AttestationView;
